import { MutationHookOptions } from '@apollo/client'
import { useCallback, useState } from 'react'

import { addReleaseNotesToPaginatedQuery } from '../cache'

import {
  CountReleaseNotesDocument,
  PaginatedReleaseNotesDocument,
  useCountReleaseNotesLazyQuery,
  useCreateReleaseNoteMutation,
} from '~generated/hooks'
import { CreateReleaseNoteMutation, CreateReleaseNoteMutationVariables } from '~generated/operations'
import { CreateReleaseNoteInput } from '~generated/types'

/* eslint-disable import/prefer-default-export */
export function useCreateReleaseNote(
  baseOptions?: MutationHookOptions<CreateReleaseNoteMutation, CreateReleaseNoteMutationVariables>
) {
  const [loading, setLoading] = useState(false)

  const [createReleaseNoteMutation, options] = useCreateReleaseNoteMutation(baseOptions)

  const [countReleaseNotesQuery] = useCountReleaseNotesLazyQuery({
    fetchPolicy: 'network-only',
  })

  const createReleaseNote = useCallback(
    async (input: CreateReleaseNoteInput) => {
      try {
        setLoading(true)

        const { data: { countReleaseNotes } = {} } = await countReleaseNotesQuery()

        await createReleaseNoteMutation({
          ...(countReleaseNotes === 0 && {
            refetchQueries: [PaginatedReleaseNotesDocument, CountReleaseNotesDocument],
            awaitRefetchQueries: true,
          }),

          variables: {
            input,
          },

          update: (cache, { data }) => {
            addReleaseNotesToPaginatedQuery(cache, [data.createReleaseNote])
          },
        })
      } finally {
        setLoading(false)
      }
    },
    [createReleaseNoteMutation, countReleaseNotesQuery]
  )

  return [createReleaseNote, { ...options, loading }] as const
}
